import repoUrls from 'src/sections/repository/urls';

import { ContainersImageTagResponse } from '../../types';
import { buildPackagesApiQueryString } from '../../utils';
import { packagesResourceFactory } from '../utils';

export const containersImageTagResource =
  packagesResourceFactory<ContainersImageTagResponse>()({
    key: 'packages-container-tag',
    pathParamNames: ['packageName', 'tagName'] as const,
    queryParamNames: [] as const,
    getRequestUrl: (context, pathParams, _queryParams) => {
      const queryString = buildPackagesApiQueryString({
        imageName: pathParams.packageName,
        tagName: pathParams.tagName,
      });

      switch (context.container) {
        case 'repository':
          return repoUrls.api.internal.containerImageTag(
            context.workspaceSlug,
            context.repositorySlug,
            queryString
          );
        default:
          throw new Error('Invalid route context');
      }
    },
  });
